/** Textos da secção "hero". Chaves planas "hero.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "hero.tagline": "Rust BR · Wipes ativos",
    "hero.logoAlt": "ZRS — Zaralha Servers",
    "hero.titleStart": "O teu próximo",
    "hero.titleHighlight": "wipe",
    "hero.titleEnd": "começa aqui.",
    "hero.subtitle":
        "Servidor Rust BR com wipes ativos, kits exclusivos, vantagens VIP e comunidade pronta para jogar.",
    "hero.ctaVips": "Ver VIPs",
    "hero.ctaKits": "Explorar Kits",
    "hero.ctaDiscord": "Entrar no Discord",
    "hero.statWipe": "Wipe",
    "hero.statWipeValue": "Sexta · Semanal",
    "hero.statUptime": "Uptime",
    "hero.statSlots": "Slots",
};
const en = {
    "hero.tagline": "Rust BR · Regular wipes",
    "hero.logoAlt": "ZRS — Zaralha Servers",
    "hero.titleStart": "Your next",
    "hero.titleHighlight": "wipe",
    "hero.titleEnd": "starts here.",
    "hero.subtitle":
        "Brazilian Rust server with regular wipes, exclusive kits, VIP perks and a community ready to play.",
    "hero.ctaVips": "View VIPs",
    "hero.ctaKits": "Explore Kits",
    "hero.ctaDiscord": "Join Discord",
    "hero.statWipe": "Wipe",
    "hero.statWipeValue": "Friday · Weekly",
    "hero.statUptime": "Uptime",
    "hero.statSlots": "Slots",
};

export default { pt, en };
